import React from "react";
import Evolution from "../Evolution/Evolution";
import "./OverviewCard.scss";

export default function OverviewCard({
  config: { title, icon, evolution },
  market,
  scrollId,
}) {
  const scrollToElement = () => {
    if (scrollId) {
      try {
        // https://robinvdvleuten.nl/blog/scroll-a-react-component-into-view/
        document
          .getElementById(scrollId)
          ?.scrollIntoView({ behavior: "smooth" });
      } catch (e) {
        document.getElementById(scrollId)?.scrollIntoView();
      }
    }
  };

  return (
    <div
      className="OverviewCard"
      onClick={scrollToElement}
      role="button"
      tabIndex={0}
    >
      <div className="OverviewCard__title">
        <img src={icon} alt="" />
        <h3>{title}</h3>
      </div>
      <div className="OverviewCard__evolution">
        <Evolution
          arrow={market?.arrow}
          price={market?.marketValue}
          origin={evolution.origin}
          currency={evolution.currency}
        />
      </div>
    </div>
  );
}
